<section class="usa-terms-and-conditions">
  <ng-container *ngIf="!showFullAgreement">
    <div
      class="usa-terms-and-conditions__container usa-terms-and-conditions__container--center"
    >
      <div class="gbm-plus-logo"></div>

      <h3
        class="usa-terms-and-conditions__acceptance-title typography-5 typography--bold typography--secondary-typeface"
      >
        Actualizamos los Términos y Condiciones de Trading USA
      </h3>

      <p class="usa-terms-and-conditions__acceptance-description">
        Para continuar invirtiendo en fracciones de acciones y ETFs del mercado
        estadounidense desde $20 en tu estrategia {{ strategyName$ | async }}
      </p>

      <div class="checkbox">
        <input
          type="checkbox"
          class="checkbox__input"
          id="accept-terms-and-conditions"
          name="accept-terms-and-conditions"
          [checked]="acceptAgreement || hasPreviouslyAcceptedAgreement || null"
          [disabled]="hasPreviouslyAcceptedAgreement || null"
        />
        <label
          for=""
          class="checkbox checkbox__label"
          (click)="toggleAcceptAgreement()"
        >
          Acepto los &nbsp;
          <button
            class="link link--semibold"
            (click)="toggleShowFullAgreement()"
          >
            Términos y Condiciones
          </button>
        </label>
      </div>

      <button
        type="button"
        class="button button--small button--dark usa-terms-and-conditions__accept-button"
        [ngClass]="{ 'button--disabled': !acceptAgreement }"
        [disabled]="!acceptAgreement || null"
        (click)="handleSubmit()"
      >
        Continuar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="showFullAgreement">
    <div class="usa-terms-and-conditions__top-band">
      <div class="gbm-plus-logo"></div>

      <button
        class="button-fab button-fab--small button-fab--clear"
        (click)="toggleShowFullAgreement()"
      >
        <div class="button-fab button-fab--small"></div>
      </button>
    </div>
    <div class="usa-terms-and-conditions__container typography--semibold">
      <h2
        class="usa-terms-and-conditions__agreement-title typography-3 typography--bold typography--secondary-typeface"
      >
        Términos y condiciones aplicables al servicio “Trading USA”
      </h2>

      <p>
        Estás muy cerca de poder adquirir y vender valores y fracciones de
        valores que cotizan en los mercados de valores de Estados Unidos de
        América (“USA”), para ello requerimos que leas y aceptes los presentes
        términos y condiciones (“Términos y Condiciones”) de este servicio
        conocido en una en Grupo Bursátil Mexicano, S.A. de C.V., Casa de Bolsa
        (“GBM”) como Trading USA (“Trading USA”).
      </p>
      <p>
        Los términos en mayúscula inicial serán los definidos en el presente
        documento, en caso de no encontrarse descritos tendrán el significado
        atribuido en el Contrato de Intermediación Bursátil celebrado con GBM.
      </p>
      <p>
        A través de este servicio, podrás girar instrucciones para la compra y
        venta de valores y fracciones de valores que cotizan en los mercados de
        valores de USA, según sean habilitados de tiempo en tiempo.
      </p>
      <p>
        En este acto, otorgas un mandato general a GBM para que por tu cuenta
        GBM reciba y transmita las órdenes de compra y venta de valores y
        fracciones de valores, (las “Operaciones”) a Drivewealth, LLC
        (“Drivewealth”) en el mercado exterior y Drivewealth será responsable de
        aceptar y procesar dichas órdenes en el mercado de valores de USA para
        su ejecución, quien también provee los servicios de liquidación y
        custodia sobre dichos valores, y respecto de los cuales reconoces que
        GBM no es responsable al no consistir en servicios bajo su control.
      </p>
      <p>
        Al contratar el servicio Trading USA, se abrirán dos cuentas, una en GBM
        (“Cuenta GBM”) y una en “Drivewealth” (“Cuenta Drivewealth”).
      </p>
      <p>
        A continuación, encontrarás una explicación sobre las funcionalidades de
        cada una de las cuentas:
      </p>
      <p>
        Cuenta GBM: Cuenta aperturada en GBM bajo el servicio conocido como
        “Trading”, es decir, el servicio de ejecución de operaciones (descrito
        en el Contrato de Intermediación Bursátil celebrado con GBM), por el
        cual tú eres quien toma las decisiones de inversión y que servirá para
        determinar tu poder de compra, para enviar y recibir los recursos de tus
        Operaciones a través de la Cuenta Drivewealth.
      </p>
      <p>
        Mediante el uso del servicio Trading USA, instruyes a GBM a realizar las
        Operaciones con Divisas (término definido y desarrollado en el Contrato
        de Intermediación Bursátil) y a girar instrucciones a Drivewealth
        derivadas de tus instrucciones.
      </p>
      <p>
        Las Operaciones con Divisas para efectos del servicio Trading USA,
        consisten en la compra y venta de dólares americanos-pesos mexicanos.
        Para mayor información puedes consultar el apartado “Operaciones con
        Divisas” en tu Contrato de Intermediación Bursátil.
      </p>
      <p>
        En la Cuenta GBM podrás realizar depósitos mediante transferencia o
        traspaso desde otra cuenta en GBM de pesos mexicanos para que
        posteriormente, en caso de querer realizar una compra de valores y/o
        fracciones de valores en la Cuenta DriveWealth, sean convertidos a
        dólares americanos (recursos líquidos), instruyendo irrevocablemente a
        GBM para que esos recursos se utilicen para liquidar las Operaciones. En
        caso de que no se reciba por parte del cliente ninguna instrucción, los
        recursos en pesos mexicanos se invertirán de conformidad con el Contrato
        de Intermediación Bursátil.
      </p>
      <p>
        Para comprar valores disponibles en la Cuenta Drivewealth, se deberán
        tener recursos líquidos suficientes en la Cuenta GBM en pesos mexicanos,
        con los cuales se adquirirán dólares americanos necesarios para liquidar
        la compra de valores y/o de fracciones de valores en la Cuenta
        Drivewealth a través de la realización de Operaciones con Divisas.
      </p>
      <p>
        En caso de realizar cualquier venta de los valores y/o de fracciones de
        valores adquiridos en la Cuenta Drivewealth, el producto de la venta se
        recibirá en la Cuenta GBM en dólares americanos, y se realizará la
        Operación con Divisas a pesos mexicanos.
      </p>
      <p>
        Antes de realizar una operación, ya sea de compra o venta, verás
        reflejado el monto a pagar por la misma, por lo que al confirmar la
        instrucción estarás aceptando el tipo de cambio implícito al confirmar
        su ejecución, y declaras conocer que el tipo de cambio por las
        Operaciones con Divisas pueden generar ingresos para GBM.
      </p>
      <p>
        Cuenta Drivewealth: Cuenta aperturada mediante la aceptación de los
        Términos Drivewealth (según dicho término se define más adelante), que
        te permite comprar y vender valores y/o fracciones de valores que
        cotizan en el mercado de valores de USA. En el caso de Operaciones sobre
        fracciones, en adición a lo establecido al respecto en los Términos
        Drivewealth, es importante que conozcas que éstas no otorgan un derecho
        de copropiedad sobre el valor al cual están referidas, sino que
        representan una obligación de pago a cargo de Drivewealth, lo cual puede
        trasladarse en limitantes en el ejercicio de ciertos derechos, o riesgos
        distintos a los que se mantendrían como accionista o tenedor de un
        valor.
      </p>
      <p>
        Las Operaciones ejecutadas a través de Drivewealth, serán registradas en
        la Cuenta Drivewealth, de acuerdo a los términos y condiciones y demás
        documentos e información sobre el servicio proporcionado por Drivewealth
        puestos a tu disposición de tiempo en tiempo (los “Términos
        Drivewealth”), y que forman parte integral de los presentes Términos y
        Condiciones.
      </p>
      <p>
        Es importante advertir que Drivewealth tiene políticas propias y está
        sujeto a la regulación de USA, y por tal motivo contempla escenarios en
        los que podrá rechazar Operaciones, incluyendo las solicitud de
        cancelaciones, y restringir de otras formas el uso de la Cuenta
        Drivewealth. Buscaremos informarte la causa de estos rechazos o
        restricción de servicios cuando esto nos sea posible.
      </p>
      <p>
        Todos los derechos corporativos y económicos otorgados por los valores
        y/o fracciones de valores comprados en la Cuenta Drivewealth se regirán
        por las políticas y documentos de Drivewealth, lo que establezcan las
        emisoras respectivas y, en su caso, de acuerdo a los procedimientos que
        te demos a conocer en su momento.
      </p>
      <p>
        Disposiciones Generales: Las Operaciones al amparo de este servicio se
        realizarán en días y horarios hábiles tanto para GBM como para
        Drivewealth. Toma en cuenta que lo anterior puede implicar que el
        servicio Trading USA no esté habilitado en días inhábiles para GBM, pero
        de operación en los mercados de valores de USA.
      </p>
      <p>
        Tipos de órdenes; únicamente se recibirán órdenes a precio de mercado.
      </p>
      <p>
        Por circunstancias incluso fuera del control de GBM y Drivewealth, la
        información de mercado mostrada en la aplicación bajo el servicio
        Trading USA puede tener un retraso respecto al precio de mercado en
        tiempo real, en caso de ser así, se buscará informar el tiempo de
        retraso. Lo anterior, con independencia que el precio mostrado al
        momento de capturar la instrucción de una Operación, reflejará el precio
        al cual se transmitirá para su ejecución, y el cual se encuentra basado
        en el precio de mercado en tiempo real.
      </p>
      <p>
        Dada la naturaleza de los servicios y los medios de comunicación
        utilizados, ni Drivewealth ni GBM pueden garantizar que éstos
        funcionarán ininterrumpidamente o sin errores. Los datos de mercado
        provienen de fuentes bajo el control de terceros, por lo que ni GBM ni
        Drivewealth pueden garantizar que éstos no contengan omisiones,
        inexactitudes o retrasos.
      </p>
      <p>
        La información de las Operaciones bajo el producto Trading USA se
        reflejará de manera integrada en la aplicación, pudiendo consultar en
        los estados de cuenta las operaciones específicas que se realizan tanto
        en la Cuenta GBM como en la Cuenta Drivewealth. Te invitamos a revisar
        en los respectivos contratos los plazos que tienes en GBM y/o en
        Drivewealth para presentar alguna aclaración.
      </p>
      <p>
        Es importante que recuerdes que en la Cuenta GBM y en la Cuenta
        Drivewealth se realizan funciones diferentes, las cuales se encuentran
        detalladas en el presente documento y en los respectivos contratos,
        mismos que contemplan la responsabilidad de cada una de las partes.
      </p>
      <p>
        GBM se reserva el derecho de cancelar o suspender, temporal o
        definitivamente, la Cuenta GBM y/o a negar la prestación del servicio
        Trading USA, entre otros motivos por: detectar incongruencias o
        inconsistencias en la información proporcionada por el usuario, o en
        caso de detectar actividades o conductas en contra de la normatividad
        aplicable, sin que tal decisión genere para el usuario derechos de
        indemnización o resarcimiento. En caso de que Drivewealth, de
        conformidad a sus políticas y/o de acuerdo a la normatividad aplicable,
        cancele la Cuenta Drivewealth, Drivewealth podrá vender los valores y/o
        fracciones de valores de la Cuenta Drivewealth y transferirá el efectivo
        correspondiente a la Cuenta GBM.
      </p>
      <p>
        En caso de fallecimiento, los recursos que se encuentren en la Cuenta
        GBM se entregarán de conformidad con el Contrato de Intermediación
        Bursátil y políticas de GBM, mientras que los valores y fracciones de
        valores en la Cuenta Drivewealth se entregarán de conformidad con las
        políticas y documentos de Drivewealth.
      </p>
      <p>
        GBM se reserva el derecho de modificar el contenido de los Términos y
        Condiciones en cualquier momento, bastando notificación a los usuarios
        sobre dicha modificación. La sola continuación en la utilización del
        servicio Trading USA implicará la plena aceptación de los nuevos
        términos y condiciones.
      </p>
      <p>
        En caso de que no estés de acuerdo con la modificación notificada,
        podrás en todo momento dejar de utilizar la Cuenta GBM para que ya no se
        siga prestando el servicio Trading USA, solicitando la entrega de los
        recursos de conformidad con los procedimientos de GBM y Drivewealth.
      </p>
      <p>
        Serán aplicables de manera supletoria los términos y condiciones
        generales de la aplicación conocida como GBM+ o GBM Plus y el Contrato
        de Intermediación Bursátil en todo aquello que resulte aplicable, lo
        anterior siempre y cuando no se contrapongan al presente documento.
      </p>
      <p>
        Para la interpretación, cumplimiento y ejecución de los Términos y
        Condiciones para la Cuenta GBM, aceptas que serán aplicables las leyes
        Federales de los Estados Unidos Mexicanos y competentes los tribunales
        de la Ciudad de México, renunciando expresamente a cualquier otro fuero
        o jurisdicción que pudiera corresponderles a las partes en razón de sus
        domicilios presentes o futuros o por cualquier otra causa.
      </p>
      <p>
        Respecto a la legislación aplicable y tribunales competentes a tu Cuenta
        Drivewealth serán aplicables aquellos señalados en los documentos e
        información de Drivewealth.
      </p>
      <p>
        Deberás comprender los Términos y Condiciones previo a realizar
        cualquier depósito y/o realizar cualquier operación, ya que GBM no será
        responsable de ninguna forma por el desconocimiento total o parcial de
        los Términos y Condiciones, Términos Drivewealth, ni por los actos o
        consecuencias atribuibles a Drivewealth como la suspensión de sus
        servicios de manera parcial o total o atribuibles a un tercero.
        presentes o futuros o por cualquier otra causa.
      </p>
    </div>
  </ng-container>
</section>
